import * as React from 'react';
import MemberHistoryActivity from '../../models/member-history-activity';
import { capitalize } from '../../core/utils';
import { DateService, DateFormat } from 'frontend-toolkit';
interface Props {
  memberHistoryActivity: MemberHistoryActivity;
}

const HistoryInfo: React.FunctionComponent<Props> = ({ memberHistoryActivity }) => {
  const unformattedTransactedAtTime = new Date(memberHistoryActivity.transactedAt);
  const formatedTransactedAtTime = DateService.dateToString(
    unformattedTransactedAtTime,
    DateFormat.DATE_WITH_TIME_AND_TIMEZONE
  );
  const event = capitalize(memberHistoryActivity.category) + ' ' + memberHistoryActivity.action;
  const description = memberHistoryActivity.description;
  const user = memberHistoryActivity.updaterName;

  return (
    <div className="Grid Grid--fit Grid--withGutter">
      <div className="Grid-cell">
        <p className="u-pad">{formatedTransactedAtTime}</p>
      </div>
      <div className="Grid-cell">
        <p className="u-pad">{user}</p>
      </div>
      <div className="Grid-cell">
        <p className="u-pad">{event}</p>
      </div>
      <div className="Grid-cell">
        <p className="u-pad">{description}</p>
      </div>
    </div>
  );
};

export default HistoryInfo;
